import packageJson from "../../package.json";
import { DEFAULT_APP_BRANDING, resolveTenant } from "./tenantBranding";

export const APP_VERSION = packageJson.version;
export const APP_VERSION_LABEL = `v ${packageJson.version}`;
export const APP_NAME = "Invoice Manager";
export const APP_LOGO = DEFAULT_APP_BRANDING.logo;
export const APP_LOADER_LOGO = DEFAULT_APP_BRANDING.loaderLogo;
export const APP_LOADER_LOGO_DARK = DEFAULT_APP_BRANDING.loaderLogoDark;
export const APP_ATTRIBUTION = "Powered by Quantum Foundry";
export const QUANTUM_FOUNDRY_LOGO = "/assets/images/quantum-foundry-logo.png";
export const UNAVAILABLE_HINT = "Not available yet";

export function getCurrentTenant() {
  if (typeof window === "undefined") return "";

  return resolveTenant(window.location.hostname, import.meta.env.VITE_TENANT);
}

/**
 * The product's own identity — logo, favicon, name — never changes per
 * tenant. A tenant's own mark leads instead, wherever one is shown; see
 * `getTenantMarkSrc` and `BrandLogo`.
 */
export function getAppBranding() {
  return {
    ...DEFAULT_APP_BRANDING,
    label: APP_NAME,
  };
}

/**
 * The image a tenant's brand mark renders — its own icon first, its wider
 * logo next, the app's default last. Mirrors the fallback order the boot
 * script in vite.config.js applies before the bundle even loads.
 */
export function getTenantMarkSrc(tenantBranding, fallbackLogo) {
  return tenantBranding?.logoIcon ?? tenantBranding?.logo ?? fallbackLogo;
}
